import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  dotBox: {
    display: "flex",
    alignItems: "stretch",
    cursor: "pointer",
    flexDirection: "column",
    position: "relative",
    width: "100%",
  },
  progress: {
    position: "absolute",
    bottom: 2,
    left: 5,
    right: 5,
  },
  iconImage: {
    width: 20,
    height: 20,
  },
  hiddenInput: {
    position: "absolute",
    top: "-9999px",
    left: "-9999px",
  },
  uploadBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    borderStyle: "dashed",
    borderWidth: "1px",
    border: "1px dashed #C6C9CA",
    minHeight: "56px",
    width: "100%",
    background: "#FFF",
    flexDirection: "column",
    padding: "6px 16px",
    overflow: "hidden",
  },
  labelWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    gap: 8,
  },
  uploadBoxErr: {
    borderColor: "red",
  },
  uploadLabel: {
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "14px",
    color: "#2A3333",
    maxWidth: 220,
  },
  caption: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "12px",
    color: "#6C7A7A",
    marginTop: 2,
  },
  sizeLabel: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: "14px",
    color: "#6C7A7A",
    marginLeft: 5,
  },
}));
